import {Photo} from '@malt/asset-utils';

export default ({baseUrl, name}, operation, options) => {
    const photo = new Photo(baseUrl, name);
    if (!photo[operation]) {
        console.error(`No such method: Photo.${operation}`);
        return new Handlebars.SafeString(`${baseUrl}/${name}`);
    }

    const url = photo[operation](options.hash);
    return new Handlebars.SafeString(url);
};
